module.exports = __webpack_public_path__ + "img/Kenya-Airways-787-1536x1229.5cbfe2aa.jpg";